<template>
    <v-dialog v-model="dialog" max-width="700px" @click:outside="hide" scrollable>
        <v-card tile>
            <v-card-title>
                <v-icon color="black" left size="40">
                    {{ editMode ? 'mdi-bell-cog' : 'mdi-bell-badge' }}
                </v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Editar' : 'Crear' }} Notificación
                    <div class="title-subtext">
                        Completa los siguientes datos
                    </div>
                </div>
                <v-spacer />
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <kimsa-select label="Tipo de Notificación" placeholder="Selecciona un tipo de notificación"
                            bolder-label :items="types" outlined solo flat dense item-text="name" item-value="id"
                            force-value :value="type" @change="type = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-select label="Cliente" placeholder="Selecciona un cliente" bolder-label :items="clients"
                            outlined solo flat dense item-text="name" item-value="id" force-value :value="client"
                            @change="client = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-select label="Usuario AMB" placeholder="Selecciona un usuario" bolder-label
                            :items="users" outlined solo flat dense item-text="name" item-value="id" force-value
                            :value="user" @change="user = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Asunto" placeholder="Ingresar Asunto" bolder-label outlined solo flat
                            dense force-value :value="name" @change="name = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="AT./" placeholder="Ingresar AT./" bolder-label outlined solo flat
                            dense force-value :value="addressed" @change="addressed = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Fecha" placeholder="Fecha" bolder-label outlined dense force-value
                            readonly :value="date" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Código" placeholder="Código generado automaticamente" readonly
                            bolder-label outlined solo flat dense force-value :value="code" />
                    </v-col>
                    <template v-if="type">
                        <v-col cols="12" v-if="type !== 1">
                            <kimsa-textarea-field label="Observaciones" placeholder="Observaciones" bolder-label
                                outlined dense force-value :value="notes" @change="notes = $event" :maxlength="600" />
                        </v-col>
                        <v-col cols="12" v-else>
                            <v-row dense align="center">
                                <v-col cols="11" class="label">
                                    Antecedentes
                                </v-col>
                                <v-col cols="1" align="center">
                                    <v-btn icon color="primary" @click="addRecord()">
                                        <v-icon>mdi-plus-circle-outline</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" v-for="(record, i) in records" :key="i" align="center">
                                    <kimsa-text-field placeholder="Nombre" outlined dense force-value
                                        :value="records[i].name" @change="records[i].name = $event"
                                        :append-icon="i !== 0 ? 'mdi-minus-circle-outline' : ''"
                                        @click:append="deleteRecord(i)" />
                                </v-col>
                            </v-row>
                        </v-col>
                    </template>
                    <v-col cols="12" align="center">
                        <v-btn @click="editMode ? editNotification() : saveNotification()" tile color="primary"
                            depressed :disabled="!valid" :loading="loading">
                            {{ editMode ? 'GUARDAR' : 'CREAR' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>

import { mapMutations, mapState } from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import Axios from "@/utils/Axios";
import KimsaTextareaField from '../common/inputs/KimsaTextareaField.vue';
import KimsaSelect from '../common/inputs/KimsaSelect.vue';

export default {
    name: "CreateExpenseReportUserDialog",
    components: { KimsaTextField, KimsaTextareaField, KimsaSelect },
    data() {
        return {
            dialog: false,
            loading: false,
            editMode: false,
            notification: null,
            types: [],
            type: null,
            clients: [],
            client: null,
            users: [],
            user: null,
            name: '',
            addressed: '',
            date: this.$moment().format('DD-MM-YYYY'),
            notes: null,
            records: [{ name: '' }],
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        valid(vm = this) {
            return !!vm.type && !!vm.client && !!vm.user && !!vm.name && !!vm.addressed
        },
        code(vm = this) {
            let shortType = vm.types.find(type => type.id === vm.type)?.short_name || ''
            let clientFirst = vm.clients.find(client => client.id === vm.client)?.name || ''
            let userFirst = vm.users.find(user => user.id === vm.user)?.name || ''
            if (!shortType || !clientFirst || !userFirst) return ''
            return `${shortType}${clientFirst[0]?.toUpperCase()}${userFirst[0]?.toUpperCase()}${vm.date.replaceAll('-', '')}`
        },
        payload(vm = this) {
            return {
                notification_type_id: vm.type,
                client_id: vm.client,
                user_id: vm.user,
                name: vm.name,
                addressed: vm.addressed,
                date: vm.date,
                code: vm.code,
                notes: vm.notes,
                records: vm.records.filter(record => !!record.name)
            }
        }
    },
    async mounted() {
        const vm = this;
        await vm.loadTypes()
        await vm.loadClients()
        await vm.loadUsers()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show() {
            const vm = this
            await vm.loadClients()
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.type = null
            vm.client = null
            vm.user = null
            vm.name = ''
            vm.addressed = ''
            vm.notes = null
            vm.records = [{ name: '' }]
        },
        loadNotification(notification) {
            const vm = this;
            vm.editMode = true
            vm.notification = notification
            vm.type = notification.notificationId
            vm.client = notification.clientId
            console.log('notification',notification);
            vm.user = notification.userId
            vm.name = notification.name
            vm.addressed = notification.addressed || ''
            vm.date = notification.date
            vm.notes = notification?.notes || null
            vm.records = notification?.records || [{name: ''}]
            vm.show()
        },
        async loadTypes() {
            const vm = this
            await Axios.get('notification-types').then(res => {
                // console.log('res loadTypes', res)
                vm.types = res.data.result.notificationTypes
            }).catch(er => {
                console.log('error loadTypes', er)
            })
        },
        async loadClients() {
            const vm = this
            await Axios.get('clients').then(res => {
                // console.log('res loadClients', res)
                vm.clients = res.data.result.clients
            }).catch(er => {
                console.log('error loadClients', er)
            })
        },
        async loadUsers() {
            const vm = this
            await Axios.post('users', {
                is_amb_user: true
            }).then(res => {
                // console.log('res loadUser', res)
                vm.users = res.data.result.users
            }).catch(er => {
                console.log('error loadUser', er)
            })
        },
        async saveNotification() {
            const vm = this
            vm.loading = true
            // console.log('saveNotification', vm)
            // console.log('payload', vm.payload)

            await Axios.post('notifications/new', vm.payload).then(res => {
                // console.log('res saveNotification',res)
                vm.toast('Notificación creada')
                vm.$emit('success')
            }).catch(error => {
                console.log('error saveNotification', error)
            }).finally(() => {
                vm.loading = false
                vm.hide()
            })
        },
        async editNotification() {
            const vm = this
            // vm.loading = true

            // console.log('editNotification', vm)
            console.log('payload', vm.payload)

            // await Axios.patch(`notifications/${vm.notification.id}/edit`, vm.payload).then(res => {
            //     // console.log('res editNotification',res)
            //     vm.toast('Notificación editada')
            //     vm.$emit('success')
            // }).catch(error => {
            //     console.log('error editNotification', error)
            // }).finally(() => {
            //     vm.loading = false
            //     vm.hide()
            // })
        },
        addRecord() {
            const vm = this;
            vm.records.push({ name: '' })
        },
        deleteRecord(index) {
            const vm = this
            vm.records.splice(index, 1)
            if (vm.records.length === 0) vm.addRecord()
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.label {
    font-size: 15px;
    color: #333333;
    font-weight: bold;
}
</style>